import axios from 'axios';
import store from './state/store';
import router from './router/index';

//Estabelecendo a urlBase
let apiHost = store.state.apiUrl;

const axiosConfigs = async (hashToken) => {
  // Obtém o token
  const token = hashToken;
  // Registra a baseURL
  axios.defaults.baseURL = apiHost;
  // Registra um timeout
  axios.defaults.timeout = 350000;

  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

  // Configura o header Content-type de todos os métodos HTTP
  axios.defaults.headers.post['Content-Type'] = 'application/json';
  axios.defaults.headers.get['Content-Type'] = 'application/json';
  axios.defaults.headers.delete['Content-Type'] = 'application/json';
  axios.defaults.headers.put['Content-Type'] = 'application/json';
};
axios.interceptors.response.use(
  function (response) {
    let url = response.config.url.split('/');

    if (
      response.headers?.['refreshed-token'] &&
      url[url.length - 1] != 'logout'
    ) {
      var decodedStr = JSON.parse(
        atob(response.headers?.['refreshed-token'].split('.')[1])
      );

      let timeInactive = new Date(decodedStr.exp * 1000);

      if (router.currentRoute.path !== '/report/details') {
        store.dispatch('setTimeInactive', timeInactive);

        localStorage.setItem('token', response.headers?.['refreshed-token']);

        delete axios.defaults.headers.common['Authorization'];

        axios.defaults.headers.common[
          'Authorization'
        ] = `Bearer ${response.headers?.['refreshed-token']}`;
      }
    }
    return response;
  },
  function (error) {
    if (error.response.data?.message == 'Credenciais inválidas') {
      store.dispatch('setTimeInactive', new Date());
      return;
    }
    return Promise.reject(error);
  }
);

export default axiosConfigs;
